import React, { MutableRefObject, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
// third party components
import { Menu as HMenu } from '@headlessui/react'

// resources
import FineArtIcon from 'assets/icons/menu-fine-art-icon.svg?component'
import PrintsIcon from 'assets/icons/menu-prints-icon.svg?component'
import ApparelIcon from 'assets/icons/menu-store-item-icon.svg?component'

// styles
import styles from './index.module.scss'
import { useRouter } from 'next/router'

const ShopMenu = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const menuRef = useRef<HTMLElement | null>(null)
  const itemRef = useRef<HTMLElement | null>(null)

  const [isMenuOpen, setIsMenuOpen] = React.useState(false) // Initially menu is hidden

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen) // Toggle the current boolean value
  }

  const handleClickOutside = event => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      itemRef.current &&
      !itemRef.current.contains(event.target)
    ) {
      setIsMenuOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })

  return (
    <div className="flex items-center">
      <HMenu>
        <HMenu.Button ref={itemRef as MutableRefObject<HTMLButtonElement>}>
          <div
            className={styles.container}
            onClick={() => {
              toggleMenu()
            }}
          >
            <div>Shop</div>
          </div>
        </HMenu.Button>
        {isMenuOpen && (
          <div ref={menuRef as MutableRefObject<HTMLDivElement>} className={styles.menuArea}>
            <div className="flex flex-col">
              <div
                className={styles.topSection}
                onClick={() => {
                  dispatch({ type: 'set', exploreTab: 0 })
                  dispatch({ type: 'set', availabilityFilter: 0 })
                  router.push('/explore')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <FineArtIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Fine Art</div>
                    <div className={styles.desc}>Authentic artwork minted on Solana</div>
                  </div>
                </div>
                <div className={styles.border} />
              </div>
              <div
                className={styles.middleSection}
                onClick={() => {
                  router.push('/studio/prints')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <PrintsIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Prints</div>
                    <div className={styles.desc}>High-quality prints of digital art</div>
                  </div>
                </div>
                <div className={styles.border} />
              </div>

              <div
                className={styles.bottomSection}
                onClick={() => {
                  router.push('/studio/merch')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <ApparelIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Apparel & Physicals</div>
                    <div className={styles.desc}>Merch, apparel, and physicals</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </HMenu>
    </div>
  )
}

export default ShopMenu
